/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { withStyles } from '@aura/components/styles'
import { useTranslation, Trans } from 'react-i18next'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import { Box, Button, Container, Grid, Radio } from '@aura/components'
import CustomLoader from '../../../../components/custom-loader'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types'
import FetchAuthenticatorStatus from '../../../../constants/fetch-authenticators'
import RegistrationContainer from '../../../../components/new-registration-container'
import sanitize from '../../../../utils/sanitize'
import styles from './styles'


const Component = ({
    authenticatorStatus,
    classes,
    data,
    error,
    getMFAOptionsStatus,
    initAuthenticators,
    mfaRequired,
    onEnroll,
    onFinish,
    onNext,
    showSetup
}) => {
    const { theme } = useAuraThemeSwitcher()

    useEffect(() => {
        initAuthenticators()
        onEnroll()
    }, [])

    const { t: translate, i18n } = useTranslation()
    const mfaSteps = [{
        img: {light: '/img/mfa/app.svg?url', dark: '/img/mfa/app-dark.svg?url'},
        description: translate('mfaEnrollment.verbiage03')
    },
{
        img: {light: '/img/mfa/Scan.svg?url', dark: '/img/mfa/Scan-dark.svg?url'},
        description: translate('mfaEnrollment.verbiage04')
    },
{
        img: {light: '/img/mfa/Security.svg?url', dark: '/img/mfa/Security-dark.svg?url'},
        description: translate('mfaEnrollment.verbiage05')
    }]

    const mfaFactors = Object.values(data).map(rec => {
        return {
            img: rec.provider === 'o' ? {light: '/img/okta_icon.svg?url', dark: '/img/okta_icon_dark.svg?url'} : {light: '/img/google_icon.svg?url', dark: '/img/google_icon_dark.svg?url'},
            appDesc: rec.factorName == 'Google Authenticator' ? 'Google Auth' : rec.factorName == 'Okta Verify with Push'? 'Okta Push' : 'Okta Code',
            ...rec
        }
    })

    const active = mfaFactors.filter(rec => rec.status === 'ACTIVE')
    const notSetup = mfaFactors.filter(rec => rec.status === 'NOT_SETUP')
    const [selectedMFA, updateSelectedMFA] = useState(null)

    const noAuthenticators = !mfaFactors || mfaFactors.length === 0
    const hasActive = active.length > 0
    const [contentStep, setContentStep] = useState((hasActive || showSetup) ? 'setup' : 'intro')
    const hasNotSetup = notSetup.length > 0
    const isContinuing = hasActive && hasNotSetup
    const isLoading = authenticatorStatus === FetchAuthenticatorStatus.DEFAULT || authenticatorStatus === FetchAuthenticatorStatus.PENDING || getMFAOptionsStatus === FetchAuthenticatorStatus.PENDING

    useEffect(() => {
        if (hasActive) {
            setContentStep('setup')
            setTitle(translate('mfa'))
        }
    }, [hasActive])

    const handleAuthenticatorClick = factorType => {
        if (hasActive) {
            return onSetupMFA(factorType)
        }
        updateSelectedMFA(factorType)

    }
    const onSetupMFA = useCallback((factorType) => {
        const factor = Object.values(data).find(rec => rec.factorType === factorType)
        onNext(factor)
    }, [onNext, selectedMFA])
    const onSetup = () => {
        setContentStep('setup')
        setTitle(translate('mfa'))

    }
useEffect(() => {
    setTitle(translate(contentStep === 'intro' && !mfaRequired ? 'mfaTitle' : 'mfa'))
},[i18n.language, mfaRequired])
    const [title, setTitle] = useState(translate((mfaRequired || showSetup) ? 'mfa' :'mfaTitle'))
    let verbiage = '';

    if (noAuthenticators) {
        verbiage = <Box component='div' dangerouslySetInnerHTML={{ __html: sanitize(translate('registrationFlow.verbiage1')) }} />
    } else if (isContinuing) {
        verbiage = <Box component='div' dangerouslySetInnerHTML={{ __html: sanitize(translate('registrationFlow.verbiage2')) }} />
    } else {
        verbiage = <Box component='div' dangerouslySetInnerHTML={{ __html: sanitize(translate('registrationFlow.verbiage3')) }} />
    }
    const setupFooter = useMemo(() => {
        return <Grid className={`${!hasActive ? classes.introButtonContainer : classes.buttonContainer} ${hasActive && classes.active}`} style={{ justifyContent: hasActive ? 'flex-end' : 'space-between', display: 'flex' }}>
            {/* Show "Finish" button when user has at least 1 active MFA */}
            {hasActive ? (
                <>
                    <div />
                    <Button
                        className={`${classes.nextButton}`}
                        color='primary'
                        onClick={() => onFinish()}
                    >
                        {translate('finish')}
                    </Button>
                </>
            ) : (
                <>
                    {/* Show "Setup Later" button when MFA not required and no active MFAs */}
                    {!mfaRequired ? (
                        <Button
                            className={`${classes.cancelButton}`}
                            color='primary'
                            onClick={() => onFinish()}
                        >
                            {translate('mfaSetupLater')}
                        </Button>
                    ) : <div />}
                    {/* Show "Next" button when user needs to select an MFA to setup */}
                    <Button
                        className={`${classes.nextButton} ${!selectedMFA ? classes.nextButtonDisabled : ''}`}
                        color='primary'
                        disabled={!selectedMFA}
                        onClick={() => onSetupMFA(selectedMFA)}
                    >
                        {translate('next')}
                    </Button>
                </>
            )}
        </Grid>

    }, [classes, translate, selectedMFA, onSetupMFA, onNext, onFinish, hasActive, mfaRequired])

    const introFooterContent = useMemo(() => {
        return <Grid className={`${classes.introButtonContainer}`} style={{ justifyContent: !mfaRequired ? 'space-between' : 'flex-end' }}>
            {!mfaRequired && <Button
                className={`${classes.cancelButton}`}
                color='primary'
                onClick={() => onFinish()}
            >
                {translate('mfaSetupLater')}
            </Button>}
            <Button
                className={`${classes.nextButton}`}
                color='primary'
                onClick={() => onSetup()}
            >
                {translate('mfaSetUp')}
            </Button>
        </Grid>
    }, [classes, translate, onSetup, onFinish, mfaRequired])

    const footerContent = useMemo(() => {
        if (contentStep === 'intro') {
            return introFooterContent
        } else if (contentStep === 'setup') {
            return setupFooter
        }
        return null
    }, [contentStep, translate, introFooterContent, setupFooter, data])

    const introContent = useMemo(() => {
        return <>
            <div className={classes.introText}>
                <p className={classes.subTitle}>{translate('mfaEnrollment.introTitle')}</p>
            </div>
            <Container className={classes.cardsContainer}>
                <p className={`${classes.subTitle}`}>{translate('mfaEnrollment.verbiage02')}</p>
                <Grid className={classes.cardsGrid}>
                    {mfaSteps.map(({ img, description }) => (
                        <Grid item xs={12} sm={6} md={4} className={classes.cardItem} key={description}>
                            <Box component='img' src={img[theme.palette.mode]} alt={description} className={classes.cardItemIcon} />
                            <p className={classes.subTitle}>{description}</p>
                        </Grid>
                    ))}
                </Grid>
                <p className={classes.subTitle}>
                    <Trans i18nKey={mfaRequired ? 'mfaRecommendedSubText' : 'mfaSubText'} components={{ bold: <strong /> }} />
                </p>
            </Container>
            <div className={classes.helpText}>
                <p className={classes.subTitle}>{translate('registrationFlow.helpText')}</p>
            </div>
        </>
    }, [classes, translate, mfaSteps, data])

    const setupContent = useMemo(() => {
        return <>
            <div className={classes.introText}>
                <p className={classes.subTitle}>{translate('authenticators.verbiage01')}</p>
            </div>
            <Grid className={`${classes.cardsContainer} ${classes.setupContainer}`}>
                {mfaFactors.map(({ img, desc, factorType, factorName, status }, idx) => (
                    <Grid className={`${classes.setUpCard} ${selectedMFA === factorType && status !== 'ACTIVE' ? classes.selectedCard : ''} ${status === 'ACTIVE' && classes.alreadySelected}`} item xs={12} sm={6} md={4} onClick={() => {
                        if (status !== 'ACTIVE') {
                            handleAuthenticatorClick(factorType)
                        }
                    }} key={desc}>

                            <Box className={classes.cardIcon}
                                key={idx}
                            >
                                <Box className={classes.accountRecoveryInfo}>
                                    <Box component='img' className={classes.setupIcon} src={img[theme.palette.mode]} alt={desc} />
                                    <p className={`${classes.imgDesc}`}>{translate(`authenticatorOptions.${factorName}`)}</p>
                                </Box>
                            <p className={classes.setupDesc}>{translate(`authenticatorOptions.${desc}`)}</p>    
                            </Box>
                            {status === 'ACTIVE' ? <Box className={classes.listItemIcon}><CheckCircleIcon className={classes.passwordSuccess} /></Box>
                             : hasActive ? <Box className={`${classes.listItemIcon} ${classes.setUp}`}>{translate('mfaSetUpText')}</Box> : <Radio checked={selectedMFA === factorType}  className={classes.radio} />}
                            
                            
                        </Grid>
                    ))}
                </Grid>
            <div className={classes.setupHelpText}>
                <p className={classes.subTitle}>{translate('registrationFlow.helpText')}</p>
            </div>
        </>
    }, [contentStep, classes, translate, mfaFactors, selectedMFA, handleAuthenticatorClick, data])

    const mainContent = useMemo(() => {
        if (isLoading) {
            return (
                <Container className={classes.customLoader}>
                    <CustomLoader
                        label={translate('loading')}
                    />
                </Container>
            )
        } else if(authenticatorStatus === FetchAuthenticatorStatus.SUCCESS && getMFAOptionsStatus !== FetchAuthenticatorStatus.PENDING){
            if (contentStep === 'intro') {
                return introContent
            } else if (contentStep === 'setup') {
                return setupContent
            }
        }   
        return null
    }, [contentStep, translate, introContent, setupContent, isLoading, authenticatorStatus, getMFAOptionsStatus])

    return (
        <RegistrationContainer {...{ footerActions : !isLoading && authenticatorStatus === FetchAuthenticatorStatus.SUCCESS && footerContent, mainContent,  title : !isLoading && authenticatorStatus === FetchAuthenticatorStatus.SUCCESS ? title : '' , verbiage }}>            
        </RegistrationContainer> 
    )
}

Component.displayName = 'Authenticators'

Component.defaultProps = {
    data: {}
}

Component.propTypes = {
    authenticatorStatus: PropTypes.string,
    classes: PropTypes.shape({
        actionRow: PropTypes.object,
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        cancelButton: PropTypes.object,
        cardsContainer: PropTypes.object,
        contentDivider: PropTypes.object,
        fieldsContainer: PropTypes.object,
        helpText: PropTypes.object,
        introText: PropTypes.object,
        nextButton: PropTypes.object,
        passwordContainer: PropTypes.object,
        passwordError: PropTypes.object,
        passwordSuccess: PropTypes.object,
        subTitle: PropTypes.object
    }),
    // data: PropTypes.object,
    // error: PropTypes.object,
    // initAuthenticators: PropTypes.func.isRequired,
    // onEnroll: PropTypes.func.isRequired,
    // onFinish: PropTypes.func.isRequired
}

export default withStyles(Component, styles)
